<template>
  <section class="hero is-fullheight-with-navbar">
    <div class="hero-head">
      <div class="container">
        <!-- <div class="row position"> -->
        <div class="columns is-vcentered" style="padding-top: 30px;">
          <div class="column is-8">
            <img src="./assets/logo.svg" alt="Sura" height="200" />
          </div>
          <div v-if="showButtonReturn" class="column is-2" @click="routerOrder">
            <b-icon class="cursorPoint" type="is-primary" icon="arrow-left" size="is-medium"></b-icon>
          </div>
          <div v-else class="column is-2">
            <b-button
              v-if="isAuthenticated"
              @click="routerOrder"
              class="is-pulled-right is-info"
              rounded
            >Histórico Pedidos</b-button>
          </div>
          <div class="column is-2">
            <a v-if="isAuthenticated" @click="goOut" class="is-pulled-right">
              <b-icon icon="logout"></b-icon>
              <span>{{ $t('app.logout') }}</span>
            </a>
          </div>
        </div>
        <!-- <b-dropdown v-if="false" v-model="lang" aria-role="list">
            <button class="button is-fullwidth" type="button" slot="trigger">
              <flag :iso="lang.icon" />
              <span class="pl-2">{{ ` ${lang.name}` }}</span>
              <b-icon icon="menu-down"></b-icon>
            </button>

            <b-dropdown-item
              v-for="lang in langs"
              :key="lang.id"
              :value="lang"
              aria-role="listitem"
            >
              <flag :iso="lang.icon" />
              <span>{{ ` ${lang.name}` }}</span>
            </b-dropdown-item>
        </b-dropdown>-->
        <!-- <b-navbar-item tag="router-link" :to="{ path: '/home' }"> -->
        <!-- <img src="./assets/logo.svg" alt="Sura" height="200" /> -->
        <!-- </b-navbar-item> -->
        <!-- <b-navbar-item v-if="isAuthenticated"> -->
        <!-- <a v-if="isAuthenticated" @click="goOut" style="float: right;">
              <b-icon icon="logout"></b-icon>
              <span>{{ $t('app.logout') }}</span>
        </a>-->
        <!-- </b-navbar-item> -->
        <!-- </div> -->
      </div>
    </div>

    <div class="hero-body">
      <offline @detected-condition="handleConnectivityChange" />
      <router-view />
    </div>
  </section>
</template>

<script>
import offline from "v-offline";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "app",
  components: {
    offline,
  },
  data() {
    return {
      firstTime: true,
      langs: [
        { id: 1, code: "en", icon: "us", name: "English" },
        { id: 2, code: "es", icon: "co", name: "Español" },
      ],
      lang: { id: 2, code: "es", icon: "co", name: "Español" },
      isPublic: true,
      labelButton: "",
      showButtonReturn: false,
    };
  },
  computed: {
    ...mapGetters("auth", {
      isAuthenticated: "isAuthenticated",
    }),
  },
  watch: {
    lang() {
      this.$i18n.locale = this.lang.code;
    },
    $route(to, from) {
      if (to.fullPath === "/order") {
        this.showButtonReturn = true;
      } else {
        this.showButtonReturn = false;
      }
    },
  },
  methods: {
    routerOrder() {
      if (this.$router.currentRoute.path === "/order") {
        this.$router.push("/home");
        this.labelButton = "Histórico Pedidos";
      } else {
        this.$router.push("/order");
        this.labelButton = "Ordenar mi pedido";
      }
    },
    handleConnectivityChange(status) {
      let message = this.$t("app.no-internet-connection");
      let type = "is-danger";
      if (status) {
        message = this.$t("app.connected");
        type = "is-success";
      }

      if (!this.firstTime) {
        this.$buefy.toast.open({ message, type });
      }

      this.firstTime = false;
    },

    ...mapActions("auth", ["logout"]),
    goOut() {
      this.logout().then(() => {
        window.location = process.env.VUE_APP_SURA_URL;
        this.$router.push("/login");
      });
    },
  },
};
</script>

<style lang="scss">
@import "./assets/scss/main.scss";
.cursorPoint {
  cursor: pointer;
}
#app {
  margin: 0 60px;
}
.hero-body {
  padding: 0;
}
.position {
  padding-top: 3%;
}
</style>
